import TableSearch from "@/components/table_search/TableSearch";
import Header from "../_components/Header";
import PaginationEl from "../_components/PaginationEl";
import MessageTable from "./_components/MessageTable";
import { useState } from "react";
import { useDebounce } from "@/hooks/useCustomDebounce";
import { useQuery } from "@tanstack/react-query";
import { MessagesProps } from "@/types/admin_types";
import api from "@/context/apiRequest";
import { MessageBreadcrumbList } from "@/l-data/admin/breadcrumLists";
import ApiError from "@/components/error404/ApiError";
import TableSkeleton from "@/components/skeletons/TableSkeleton";


export default function Messages() {

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 1000)

  const { data: messages, isLoading, isError } = useQuery({
    queryKey: ['messages', debouncedSearch, page],
    queryFn: async () => 
    await api().get(`/api/v1/admin/contact-messages?search=${search}&page=${search ? 1 : page}`).then((res) => {
      return res?.data?.data as MessagesProps;
    })
  })

  return (
    <main>
      <Header title={"Message Display"} list={MessageBreadcrumbList}/>
      <div className='flex items-center justify-between py-6'>
        <TableSearch search={search} setSearch={setSearch}/>
      </div>
      {messages && <MessageTable data={messages}/>}
      {messages && <PaginationEl setPage={setPage} data={messages} />}
      {isLoading && <TableSkeleton/>}
      {isError && <ApiError/>}
    </main>
  )
}
